import { useSelector } from "react-redux";
import FormaCotizador from "./_FormaCotizador";

export default function Cotizador() {
  const { step } = useSelector((state) => state.cotizacionesReducer.cotizacion);

  return step > 2 ? <FormaCotizador /> : <></>;
}
